// API client for Misbah Khan portfolio CMS
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "mk_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const resolveImage = (url) => {
  if (!url) return url;
  if (/^https?:\/\//.test(url)) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};

async function request(path, { method = "GET", body, auth = false, isForm = false } = {}) {
  const headers = {};
  if (!isForm && body !== undefined) headers["Content-Type"] = "application/json";
  if (auth) {
    const t = getToken();
    if (t) headers["Authorization"] = `Bearer ${t}`;
  }
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: isForm ? body : body !== undefined ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let detail;
    try {
      const j = await res.json();
      detail = j.detail || j.message || res.statusText;
    } catch {
      detail = res.statusText;
    }
    const err = new Error(typeof detail === "string" ? detail : JSON.stringify(detail));
    err.status = res.status;
    throw err;
  }
  if (res.status === 204) return null;
  return res.json();
}

export const api = {
  // public
  getSite: () => request("/site"),
  getAbout: () => request("/about"),
  listProjects: () => request("/projects"),
  listServices: () => request("/services"),
  listTestimonials: () => request("/testimonials"),
  sendMessage: (body) => request("/messages", { method: "POST", body }),

  // auth
  login: (email, password) =>
    request("/auth/login", { method: "POST", body: { email, password } }),
  me: () => request("/auth/me", { auth: true }),
  changePassword: (current_password, new_password) =>
    request("/auth/change-password", {
      method: "POST",
      auth: true,
      body: { current_password, new_password },
    }),

  // upload
  upload: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return request("/upload", { method: "POST", auth: true, body: fd, isForm: true });
  },

  // site / about
  saveSite: (body) => request("/site", { method: "PUT", auth: true, body }),
  saveAbout: (body) => request("/about", { method: "PUT", auth: true, body }),

  // projects
  createProject: (body) => request("/projects", { method: "POST", auth: true, body }),
  updateProject: (id, body) => request(`/projects/${id}`, { method: "PUT", auth: true, body }),
  deleteProject: (id) => request(`/projects/${id}`, { method: "DELETE", auth: true }),

  // services
  createService: (body) => request("/services", { method: "POST", auth: true, body }),
  updateService: (id, body) => request(`/services/${id}`, { method: "PUT", auth: true, body }),
  deleteService: (id) => request(`/services/${id}`, { method: "DELETE", auth: true }),

  // testimonials
  createTestimonial: (body) => request("/testimonials", { method: "POST", auth: true, body }),
  updateTestimonial: (id, body) =>
    request(`/testimonials/${id}`, { method: "PUT", auth: true, body }),
  deleteTestimonial: (id) => request(`/testimonials/${id}`, { method: "DELETE", auth: true }),

  // messages
  listMessages: () => request("/messages", { auth: true }),
  markMessageRead: (id) =>
    request(`/messages/${id}/read`, { method: "PATCH", auth: true }),
  deleteMessage: (id) => request(`/messages/${id}`, { method: "DELETE", auth: true }),
};
